import { useState, useEffect } from 'react'
import moment from 'moment'
import { SolidTrashCan } from '@rushable/icons'
import { toast } from 'react-toastify'
import Modal from 'components/Modal'
import Button from 'components/Button'
import ParagraphInput from 'components/ParagraphInput'
import Checkbox from 'components/Checkbox'
import { DateAndTimePicker } from 'components/DatePicker'
import Label from 'components/Label'
import { createCommentApi, updateCommentApi, deleteCommentApi } from 'redux/account'

export type TEditCommentModalProps = {
  onboardingId: string
  comment?: Record<string, any> // 编辑时当前 comment 信息
  open: boolean
  toggle: () => void
  onSuccess: () => void
}

export default function EditCommentModal({
  onboardingId,
  comment,
  open,
  toggle,
  onSuccess,
}: TEditCommentModalProps) {
  const [value, setValue] = useState('')
  const [remindAt, setRemindAt] = useState('')
  const [check, setCheck] = useState(false)
  const [loading, setLoading] = useState({ ok: false, delete: false })
  const isEdit = !!comment?.id

  useEffect(() => {
    if (comment?.id) {
      setValue(comment.msg)
      setRemindAt(comment.remindAt)
      setCheck(!!comment.notification)
    }
    if (!open) {
      // modal 关闭时清空数据
      setValue('')
      setRemindAt('')
      setCheck(false)
    }
  }, [comment?.id, open])

  const handleSubmit = async () => {
    const params = {
      onboarding_id: onboardingId,
      content: value,
      notification: check ? 1 : 0,
      remind_at: remindAt,
    }
    setLoading(prev => ({ ...prev, ok: true }))
    try {
      let res = null
      if (isEdit) {
        res = await updateCommentApi(comment!.id, params)
      } else {
        res = await createCommentApi(params)
      }
      toast.success(res.message)
      onSuccess()
      toggle()
    } catch (error: any) {
      toast.error(error.message)
    }
    setLoading(prev => ({ ...prev, ok: false }))
  }

  const handleDelete = async () => {
    setLoading(prev => ({ ...prev, delete: true }))
    try {
      let res = await deleteCommentApi(comment!.id)
      toast.success(res.message)
      onSuccess()
      toggle()
    } catch (error: any) {
      toast.error(error.message)
    }
    setLoading(prev => ({ ...prev, delete: false }))
  }

  return (
    <Modal
      open={open}
      toggle={toggle}
      title={`${isEdit ? 'EDIT' : 'ADD'} COMMENT`}
      okText={isEdit ? 'UPDATE' : 'CONFIRM'}
      cancelText='CLOSE'
      onOk={handleSubmit}
      okButtonProps={{ loading: loading.ok, disabled: loading.delete }}
      footerLeftElement={
        isEdit ? (
          <Button
            color='warning'
            loading={loading.delete}
            disabled={loading.ok}
            iconBefore={<SolidTrashCan size={12} />}
            theme='text'
            onClick={handleDelete}
          >
            DELETE
          </Button>
        ) : (
          <></>
        )
      }
    >
      <div className='w-full text-left'>
        <ParagraphInput
          name='DESCRIPTION'
          label='DESCRIPTION'
          placeholder='Input'
          value={value}
          onChange={e => setValue(e.target.value)}
        />
        <Label className='mt-4 mb-2'>REMINDER SCHEDULED TIME</Label>
        <DateAndTimePicker
          value={remindAt}
          // timezone={RUSHABLE_TIMEZONE}
          disabledDate={current =>
            current && current < moment().add(-1, 'day').endOf('day')
          }
          noExpired
          showTime={{
            use12Hours: true,
            minuteStep: 15,
            format: 'HH:mm',
          }}
          onChange={(date: any, dateString: any) => {
            setRemindAt(dateString)
          }}
        />
        <Checkbox
          className='mt-4'
          size={16}
          checked={check}
          onChange={e => {
            setCheck(e.target.checked)
          }}
        >
          Push notification to Slack channel
        </Checkbox>
      </div>
    </Modal>
  )
}
